import { EditCalendarRounded } from '@mui/icons-material';
import { IconButton, IconButtonProps, SvgIconProps, useTheme } from '@mui/material';

interface IProps {
  buttonProps?: IconButtonProps;
  iconProps?: SvgIconProps;
  isMarked: boolean;
}

const ButtonBookmark = ({ isMarked, buttonProps, iconProps }: IProps) => {
  const { palette } = useTheme();

  return (
    <IconButton
      color={isMarked ? 'primary' : 'default'}
      sx={{
        border: isMarked ? '1px solid' + palette.primaryStateHover.main : '1px solid' + palette.divider,
        background: isMarked ? palette.primaryStateHover.main : 'transparent',
      }}
      {...buttonProps}
    >
      <EditCalendarRounded fill={isMarked ? palette.primary.main : 'transparent'} {...iconProps} />
    </IconButton>
  );
};

export default ButtonBookmark;
